import { Tooltip } from "antd";
import VerifiedBadge from "../../assets/badge";

export const RoleBadge = ({ p3mSuperAdmin, superAdmin, admin, owner }: { p3mSuperAdmin: boolean, superAdmin: boolean, admin: boolean, owner: boolean }) => {
    if (!p3mSuperAdmin && !superAdmin && !admin && !owner) return null;

    let roleText = "";
    let authorityText = "";
    let badgeColor = '';

    if (p3mSuperAdmin) {
        roleText = "P3M Super Admin";
        authorityText = "Full system access and control over all platform features";
        badgeColor = '#2f54eb';
    } else if (superAdmin) {
        roleText = "Super Admin";
        authorityText = "Advanced permissions for managing users and content";
        badgeColor = '#faad14';
    } else if (admin) {
        roleText = "Admin";
        authorityText = "Moderation capabilities and content management rights";
        badgeColor = '#52c41a';
    } else if (owner) {
        roleText = "Owner";
        authorityText = "Complete authority over personal posts and profile settings";
        badgeColor = '#722ed1';
    }

    return (
        <Tooltip title={`${roleText}: ${authorityText}`} placement="right" arrow={true} >
            <span
                className="verified-badge"
            >
                <VerifiedBadge size={20} color={badgeColor} />
            </span>
        </Tooltip>
    );
};
